import React, { useEffect } from "react"

import FooterSection from "./components/FooterSection"
import HeaderSection from "./components/HeaderSection"
import SectionRenderer from "./SectionRenderer"

const WebsiteBuilderV2PublicPage = ({
  practice,
  page,
  sections,
  theme,
  viewingInBuilder = false,
  deviceType = "desktop"
}) => {
  // Handle anchor scrolling when page loads
  useEffect(() => {
    const handleAnchorScroll = () => {
      const hash = window.location.hash
      if (hash) {
        // Remove the # from the hash
        const elementId = hash.substring(1)
        const element = document.getElementById(elementId)

        if (element) {
          // Add a small delay to ensure the page is fully rendered
          setTimeout(() => {
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            })
          }, 500) // 500ms delay
        }
      }
    }

    // Run on initial load
    handleAnchorScroll()

    // Also listen for hash changes (in case user navigates with anchors)
    window.addEventListener("hashchange", handleAnchorScroll)

    return () => {
      window.removeEventListener("hashchange", handleAnchorScroll)
    }
  }, [])

  // Handle missing or empty sections
  if (!sections || !Array.isArray(sections) || sections.length === 0) {
    return (
      <div className="website-builder-v2-public py-20 text-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-800">Welcome to {practice?.name || "this practice"}</h2>
        <p className="text-gray-600">This page is being set up. Please check back soon!</p>
        <div className="mt-4 text-sm text-gray-500">
          Debug: No sections found for page &quot;{page?.title || "Unknown"}&quot;
        </div>
      </div>
    )
  }

  return (
    <div className="website-builder-v2-public">
      {/* Header */}
      <HeaderSection
        section={{ id: "header", settings: {} }}
        practice={practice}
        theme={theme}
        highlightedField={null}
        deviceType={deviceType}
      />

      {/* Render all visible sections using the SectionRenderer */}
      {sections
        .filter((section) => !section.hidden)
        .map((section) => (
          <SectionRenderer
            key={section.id}
            section={section}
            practice={practice}
            theme={theme}
            highlightedField={null}
            viewingInBuilder={viewingInBuilder}
            pageSlug={page?.slug}
            deviceType={deviceType}
          />
        ))}

      {/* Footer */}
      <FooterSection
        section={{ id: "footer", settings: {} }}
        practice={practice}
        theme={theme}
        highlightedField={null}
      />
    </div>
  )
}

export default WebsiteBuilderV2PublicPage
